import { fromJS } from 'immutable/dist/immutable';
import {
  normalizeInitialFormValues, fieldToNumber, fieldTrimmed,
} from '../../../../form/formUtilities';

export const createInitialForm = earthquake => fromJS({
  id: normalizeInitialFormValues(earthquake, ['id']),
  flagDuplicate: normalizeInitialFormValues(earthquake, ['flagDuplicate'], false),
  year: normalizeInitialFormValues(earthquake, ['year']),
  month: normalizeInitialFormValues(earthquake, ['month']),
  day: normalizeInitialFormValues(earthquake, ['day']),
  hour: normalizeInitialFormValues(earthquake, ['hour']),
  minute: normalizeInitialFormValues(earthquake, ['minute']),
  second: normalizeInitialFormValues(earthquake, ['second']),
  latitude: normalizeInitialFormValues(earthquake, ['latitude']),
  longitude: normalizeInitialFormValues(earthquake, ['longitude']),
  eqDepth: normalizeInitialFormValues(earthquake, ['eqDepth']),
  locationName: normalizeInitialFormValues(earthquake, ['locationName']),
  area: normalizeInitialFormValues(earthquake, ['area']),
  country: normalizeInitialFormValues(earthquake, ['country']),
  eqMagUnk: normalizeInitialFormValues(earthquake, ['eqMagUnk']),
  eqMagMb: normalizeInitialFormValues(earthquake, ['eqMagMb']),
  eqMagMs: normalizeInitialFormValues(earthquake, ['eqMagMs']),
  eqMagMw: normalizeInitialFormValues(earthquake, ['eqMagMw']),
  intensity: normalizeInitialFormValues(earthquake, ['intensity']),
  damageMillionsDollars: normalizeInitialFormValues(earthquake, ['damageMillionsDollars']),
  damageAmountOrder: normalizeInitialFormValues(earthquake, ['damageAmountOrder']),
  deaths: normalizeInitialFormValues(earthquake, ['deaths']),
  deathsAmountOrder: normalizeInitialFormValues(earthquake, ['deathsAmountOrder']),
  injuries: normalizeInitialFormValues(earthquake, ['injuries']),
  injuriesAmountOrder: normalizeInitialFormValues(earthquake, ['injuriesAmountOrder']),
  comments: normalizeInitialFormValues(earthquake, ['comments']),
  housesDestroyed: normalizeInitialFormValues(earthquake, ['housesDestroyed']),
  housesDestroyedAmountOrder: normalizeInitialFormValues(earthquake, ['housesDestroyedAmountOrder']),
  deathsTotal: normalizeInitialFormValues(earthquake, ['deathsTotal']),
  deathsAmountOrderTotal: normalizeInitialFormValues(earthquake, ['deathsAmountOrderTotal']),
  injuriesTotal: normalizeInitialFormValues(earthquake, ['injuriesTotal']),
  injuriesAmountOrderTotal: normalizeInitialFormValues(earthquake, ['injuriesAmountOrderTotal']),
  damageMillionsDollarsTotal: normalizeInitialFormValues(earthquake, ['damageMillionsDollarsTotal']),
  damageAmountOrderTotal: normalizeInitialFormValues(earthquake, ['damageAmountOrderTotal']),
  housesDestroyedTotal: normalizeInitialFormValues(earthquake, ['housesDestroyedTotal']),
  housesDestroyedAmountOrderTotal: normalizeInitialFormValues(earthquake, ['housesDestroyedAmountOrderTotal']),
  missing: normalizeInitialFormValues(earthquake, ['missing']),
  missingAmountOrder: normalizeInitialFormValues(earthquake, ['missingAmountOrder']),
  missingTotal: normalizeInitialFormValues(earthquake, ['missingTotal']),
  missingAmountOrderTotal: normalizeInitialFormValues(earthquake, ['missingAmountOrderTotal']),
  eqMagMl: normalizeInitialFormValues(earthquake, ['eqMagMl']),
  eqMagMfa: normalizeInitialFormValues(earthquake, ['eqMagMfa']),
  flagEpicenterChk: normalizeInitialFormValues(earthquake, ['flagEpicenterChk'], false),
  flagMagnitudeChk: normalizeInitialFormValues(earthquake, ['flagMagnitudeChk'], false),
  flagEffectsChk: normalizeInitialFormValues(earthquake, ['flagEffectsChk'], false),
  regionCode: normalizeInitialFormValues(earthquake, ['regionCode']),
  housesDamaged: normalizeInitialFormValues(earthquake, ['housesDamaged']),
  housesDamagedTotal: normalizeInitialFormValues(earthquake, ['housesDamagedTotal']),
  housesDamagedAmountOrder: normalizeInitialFormValues(earthquake, ['housesDamagedAmountOrder']),
  housesDamagedAmountOrderTotal: normalizeInitialFormValues(earthquake, ['housesDamagedAmountOrderTotal']),
  tsunamiEventId: normalizeInitialFormValues(earthquake, ['tsunamiEventId']),
  volcanoEventId: normalizeInitialFormValues(earthquake, ['volcanoEventId']),
  referenceIds: earthquake && earthquake.get('referenceIds') ? earthquake.get('referenceIds').map(v => `${v}`) : [],
  publish: normalizeInitialFormValues(earthquake, ['publish'], true),
});

export const earthquakeEditModel = fromJS({
  name: 'earthquakeEditForm',
  initialValues: createInitialForm(),
});

export const formToJson = form => ({
  id: fieldToNumber(form.get('id')),
  flagDuplicate: Boolean(form.get('flagDuplicate')),
  year: fieldToNumber(form.get('year')),
  month: fieldToNumber(form.get('month')),
  day: fieldToNumber(form.get('day')),
  hour: fieldToNumber(form.get('hour')),
  minute: fieldToNumber(form.get('minute')),
  second: fieldToNumber(form.get('second')),
  latitude: fieldToNumber(form.get('latitude')),
  longitude: fieldToNumber(form.get('longitude')),
  eqDepth: fieldToNumber(form.get('eqDepth')),
  locationName: fieldTrimmed(form.get('locationName')),
  area: fieldTrimmed(form.get('area')),
  country: fieldTrimmed(form.get('country')),
  eqMagUnk: fieldToNumber(form.get('eqMagUnk')),
  eqMagMb: fieldToNumber(form.get('eqMagMb')),
  eqMagMs: fieldToNumber(form.get('eqMagMs')),
  eqMagMw: fieldToNumber(form.get('eqMagMw')),
  intensity: fieldToNumber(form.get('intensity')),
  damageMillionsDollars: fieldToNumber(form.get('damageMillionsDollars')),
  damageAmountOrder: fieldToNumber(form.get('damageAmountOrder')),
  deaths: fieldToNumber(form.get('deaths')),
  deathsAmountOrder: fieldToNumber(form.get('deathsAmountOrder')),
  injuries: fieldToNumber(form.get('injuries')),
  injuriesAmountOrder: fieldToNumber(form.get('injuriesAmountOrder')),
  comments: fieldTrimmed(form.get('comments')),
  housesDestroyed: fieldToNumber(form.get('housesDestroyed')),
  housesDestroyedAmountOrder: fieldToNumber(form.get('housesDestroyedAmountOrder')),
  deathsTotal: fieldToNumber(form.get('deathsTotal')),
  deathsAmountOrderTotal: fieldToNumber(form.get('deathsAmountOrderTotal')),
  injuriesTotal: fieldToNumber(form.get('injuriesTotal')),
  injuriesAmountOrderTotal: fieldToNumber(form.get('injuriesAmountOrderTotal')),
  damageMillionsDollarsTotal: fieldToNumber(form.get('damageMillionsDollarsTotal')),
  damageAmountOrderTotal: fieldToNumber(form.get('damageAmountOrderTotal')),
  housesDestroyedTotal: fieldToNumber(form.get('housesDestroyedTotal')),
  housesDestroyedAmountOrderTotal: fieldToNumber(form.get('housesDestroyedAmountOrderTotal')),
  missing: fieldToNumber(form.get('missing')),
  missingAmountOrder: fieldToNumber(form.get('missingAmountOrder')),
  missingTotal: fieldToNumber(form.get('missingTotal')),
  missingAmountOrderTotal: fieldToNumber(form.get('missingAmountOrderTotal')),
  eqMagMl: fieldToNumber(form.get('eqMagMl')),
  eqMagMfa: fieldToNumber(form.get('eqMagMfa')),
  flagEpicenterChk: Boolean(form.get('flagEpicenterChk')),
  flagMagnitudeChk: Boolean(form.get('flagMagnitudeChk')),
  flagEffectsChk: Boolean(form.get('flagEffectsChk')),
  regionCode: fieldToNumber(form.get('regionCode')),
  housesDamaged: fieldToNumber(form.get('housesDamaged')),
  housesDamagedTotal: fieldToNumber(form.get('housesDamagedTotal')),
  housesDamagedAmountOrder: fieldToNumber(form.get('housesDamagedAmountOrder')),
  housesDamagedAmountOrderTotal: fieldToNumber(form.get('housesDamagedAmountOrderTotal')),
  tsunamiEventId: fieldToNumber(form.get('tsunamiEventId')),
  volcanoEventId: fieldToNumber(form.get('volcanoEventId')),
  referenceIds: fromJS(form.get('referenceIds')).map(fieldToNumber).filter(value => value != null),
  publish: Boolean(form.get('publish')),
});
